import "./styles.sass";

import React, { FC, useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import StatItem from "../../components/statItem/statItem";
import { Context } from "../..";

const Dashboard: FC = () => {
  const { users } = useContext(Context);

  const [statsData, setStatsData] = useState<any>([]);

  useEffect(() => {
    users
      .fetchStatistics()
      .then((data) => {
        setStatsData(data);
      })
      .catch(console.log);
  }, []);

  return (
    <div className="dashboard">
      <div className="dash-header">
        <div className="title">Campaign overview</div>
      </div>
      <div className="stats">
        <StatItem
          icon="save-2.svg"
          title="Total users"
          mainInfo={statsData.totalUsers}
          subInfo={`${statsData?.growthPercentage || "0"}%`}
          diff={statsData.growthPercentage > 0 ? "up" : "down"}
        />
        <StatItem
          icon="save-2.svg"
          title="New users / month"
          mainInfo={statsData.newUsersCount}
          subInfo={`${statsData?.newUsersGrowthPercentage || "0"}%`}
          diff={statsData.newUsersGrowthPercentage > 0 ? "up" : "down"}
        />
      </div>
    </div>
  );
};

export default observer(Dashboard);
